<div content-red-toggle class="{{classTam}}" [ngClass]="{'invalid': invalid}" [attr.disable]='disable'>
  <div class="red-toggle">
    <button class="red-toggle__btn" [ngClass]="{ 'red-toggle__btn--on': value, 'red-toggle__btn--off': !value }"
      (click)="onClick()">
      <span class="content-text">
        <span class="lbtrue">{{lbTrue}}</span>
        <span class="lbfalse">{{lbFalse}}</span>
      </span>
    </button>
  </div>
</div>